import { MouseEvent } from 'react';
import Role, { householdDataViewerRoles, MapType } from '../../types/enums';
import useAuth from '../../utils/auth';
import ToggleGroup from '../toggleGroup';

export default function MapToggle({ mapType, setMapType }: { mapType: MapType; setMapType: (e: MouseEvent<HTMLButtonElement>) => void }) {
  const authUser = useAuth();

  const hasHouseholdLevelAccess: boolean = householdDataViewerRoles.includes(authUser.role satisfies Role);

  return (
    <ToggleGroup
      ariaLabel="Map type"
      selected={mapType}
      onChange={setMapType}
      className="m-4"
      options={[
        {
          value: MapType.HouseholdMap,
          label: MapType.HouseholdMap,
          disabled: !hasHouseholdLevelAccess,
          disabledTitle: 'Unavailable for your level of access.',
        },
        {
          value: MapType.WardMap,
          label: MapType.WardMap
        },
        {
          value: MapType.LocalAuthorityMap,
          label: MapType.LocalAuthorityMap,
        },
      ]}
    />
  );
}
